import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Order } from 'src/services/classes/models/order.interface';
import { Address } from 'src/services/classes/models/restaurant.interface';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit, OnDestroy {
  @Input() orderDetails!: Order;
  @Output() handleOrderUpdate = new EventEmitter<string>();
  @Output() handleOrderStatusUpdate = new EventEmitter<Order>();

  // Countdown properties
  countdownText: string = '';
  showCountdown: boolean = false;
  private countdownInterval: any;

  ngOnInit() {
    addEventListener('reload-order', () => {
      setTimeout(() => {
        this.handleOrderUpdate.emit('reload-order-details');
      }, 0);
    });
    
    // Start countdown check
    this.startCountdownCheck();
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  startCountdownCheck() {
    this.updateCountdown();
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    if (this.orderDetails?.inTransit && this.orderDetails?.reservationEndTime) {
      const now = new Date().getTime();
      const endTime = new Date(this.orderDetails.reservationEndTime).getTime();
      const timeDiff = endTime - now;

      // Show countdown when within 20 minutes (1,200,000 milliseconds)
      if (timeDiff > 0 && timeDiff <= 1200000) {
        this.showCountdown = true;
        const minutes = Math.floor(timeDiff / 60000);
        const seconds = Math.floor((timeDiff % 60000) / 1000);
        this.countdownText = `${minutes}m ${seconds}s`;
      } else if (timeDiff <= 0) {
        this.showCountdown = true;
        this.countdownText = 'EXPIRED';
      } else {
        this.showCountdown = false;
      }
    } else {
      this.showCountdown = false;
    }
  }

  getObjectLength(dishes: any) {
    return Object.keys(dishes).length;
  }

  isImageValid(control: string) {
    return /^(ftp|https|http)?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/.test(
      control
    );
  }

  openDrawer() {
    dispatchEvent(
      new CustomEvent('open-drawer', {
        bubbles: false,
        cancelable: false,
        detail: this.orderDetails,
      })
    );
  }

  createAddress(address: Address | undefined) {
    if (address !== null) {
      const addressLine = address?.line || '';
      const addressCity = address?.city || '';
      const addressState = address?.state || '';
      const addressCountry = address?.country || '';
      const fullAddress = `${addressLine} ${addressCity}, ${addressState}, ${addressCountry}`;

      return fullAddress || '';
    }
    return '';
  }
}
